import { createContext } from 'react';


export default createContext({
  isAuthenticated: false,
  userType: 'renter'
});
